var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCabal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "#00538b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.88,15.71c.19.42,4.44,4.42,4.68,4.79.57.85-.62,1.66-1,2-1.07,1.08-2.13,2.06-3.22,3.12-.41.39-.48.31-.48,1.08,0,1-.06,4.14.05,4.74l9-8.84c.39-.36,1-.77,1.06-1.56,0-1-1.33-1.83-2.27-2.86-1.56-1.69-3.56-3.45-5.22-5.12-.45-.44-.82-.86-1.25-1.29a12.94,12.94,0,0,0-1.37-1.25v5.17ZM20.09,31.46c.1-.81,0-4.07,0-5.12,0-.45-3.22-3.34-3.74-3.87-.32-.32-1.1-.88-1.08-1.5s1.71-2,2.38-2.73c.41-.46.82-.84,1.26-1.28.66-.66,1.18-.95,1.18-1.45v-5c-.45.26-5.39,5.34-6.49,6.29s-1.55,1.66-2.57,2.59c-1.94,1.76-1.07,2.24,1.25,4.39,1.75,1.63,3.45,3.58,5.2,5.14.48.44.82.81,1.28,1.25a12.88,12.88,0,0,1,1.29,1.26Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabal);
export default __webpack_public_path__ + "static/media/cabal.405f8bb5a819c5f85430ff660ad95281.svg";
export { ForwardRef as ReactComponent };